import { useStore } from "../context/StoreContext";
import { useLang } from "../context/LanguageContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function resolveAsset(url) {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:")) return url;
  return `${BACKEND_URL}${url}`;
}

export function useSiteContent() {
  const { settings } = useStore();
  const { lang, t } = useLang();
  const content = settings.content || {};
  // Text overrides apply only for Spanish (primary language); other languages keep translations
  const txt = (key, tkey) => (content[key] && lang === "es") ? content[key] : t(tkey);
  const img = (key, fallback) => resolveAsset(content[key]) || fallback;
  const raw = (key, fallback = "") => content[key] || fallback;
  const num = (key, fallback) => {
    const v = content[key];
    return v !== undefined && v !== null && v !== "" ? Number(v) : fallback;
  };
  return { content, txt, img, raw, num, lang, t, brand: settings.brand_name };
}
